import { render } from "./BetterData.vue?vue&type=template&id=cc9f7f10"
import script from "./BetterData.vue?vue&type=script&lang=js"
export * from "./BetterData.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__